import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { approveindividualloan, pendingindividualloan } from "../../../services/admin";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import ImageUrl from "../../../ImageUrl";
import Swal from "sweetalert2";
import { isAdmin } from "../../../utils/roles";

/**
 * Opens a member's profile in a new tab so the approver keeps their place in
 * the pending list. The app is hash-routed, so the URL is built from the
 * current origin + path rather than assuming the app is served from root.
 */
function openMemberProfile(memberId) {
    if (!memberId) return;
    const { origin, pathname } = window.location;
    window.open(
        `${origin}${pathname}#/member/memberprofile/${memberId}`,
        "_blank",
        "noopener"
    );
}

export default function IndividualLoanApproval() {
    const [filterProduct, setFilterProduct] = useState([]);
    const [lpath, setLPath] = useState("");

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 260,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                // The view icon shows for every role: non-admins still need to
                // check a member's details even though they cannot approve.
                const view = (
                    <a
                        className="btn-sm btn-info me-2"
                        title="View Member Profile (opens in new tab)"
                        onClick={() => openMemberProfile(params.data.loan_member)}
                    >
                        <i className="fa fa-eye"></i>
                    </a>
                );

                if (isAdmin()) {
                    return (
                        <div className="text-center">
                            {view}
                            <a className="btn-sm btn-success me-2" onClick={() => loansta(params.value, 1)}>
                                <i className="fa fa-check"></i> Approve
                            </a>
                            <a className="btn-sm btn-danger me-2" onClick={() => loansta(params.value, 2)}>
                                <i className="fa fa-times"></i> Cancel
                            </a>
                        </div>
                    );
                } else {
                    return (
                        <div className="text-center">
                            {view}
                            <span className="text-danger">Waiting for Approval</span>
                        </div>
                    );
                }
            },
        },
        {
            headerName: "Status",
            field: "loan_status_string",
            width: 130,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: function (params) {
                if (params.value === "Not Approved") {
                    return { color: "red" };
                } else if (params.value === "Approved") {
                    return { color: "green" };
                } else {
                    return { color: "blue" };
                }
            },
        },
        {
            headerName: "Photo",
            field: "photo",
            width: 100,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return (
                        <img
                            src={ImageUrl + lpath + params.value}
                            alt="img"
                            style={{ width: "50px", height: "50px" }}
                            onError={(e) => errorphoto(e)}
                        />
                    );
                }
            }
        },
        {
            headerName: "Member",
            field: "member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
       
        {
            headerName: "Phone",
            field: "phone_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan Amount",
            field: "loan_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan Date",
            field: "loan_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Due Start Date",
            field: "loan_due_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
    ];

    function loansta(lid, status) {
        if (status == 1) {
            Swal.fire({
                text: "Are you sure want to approve the individual loan for this member?",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#19b159",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Approve",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", lid);
                    temp.append("statusupdate", status);
                    approveindividualloan(temp).then((response) => {
                        if (response.status === true) {
                            toast.success(response.message);
                            funlist();
                        }
                    })
                }
            });
        } else if (status == 2) {
            Swal.fire({
                text: "Are you sure want to cancel the individual loan for this member?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ac0404",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", lid);
                    temp.append("statusupdate", status);
                    approveindividualloan(temp).then((response) => {
                        if (response.status === true) {
                            toast.success(response.message);
                            funlist();
                        }
                    })
                }
            });
        }
    }

    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        setFilterProduct([]);
        pendingindividualloan(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
                setLPath(res.data.path);
            }
        })
    }

    function errorphoto(ev) {
        ev.target.src = require("../../../assets/images/women.png");
        ev.target.onerror = null;
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Pending Individual Loan</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Individual Loan</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Pending Individual Loan
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Pending Individual Loan List
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
